import React from 'react';

function LabeledProperty({
  title,
  value,
  timeString = false,
}: {
  title: string;
  value: string | number | null;
  timeString?: boolean;
}) {
  if (value === '' || !value || (timeString && value === '0001-01-01T00:00:00')) return <></>;

  if (timeString) value = new Date(value).toLocaleTimeString();

  return (
    <div>
      <span className="pr-2 font-bold capitalize">{title + ':'}</span>
      {value}
    </div>
  );
}

export default LabeledProperty;
